<template>
  <div>
    <b-modal
      id="buy-create"
      hide-footer
      no-close-on-backdrop
      @show="clearFields"
      modal-class="modern-modal"
      size="lg"
    >
      <template v-slot:modal-title>
        <div class="modal-title-modern">
          <i class="fas fa-shopping-cart mr-2"></i>
          Criar Nova Lista de Compras
        </div>
      </template>

      <div class="filters-section">
        <div class="filters-card">
          <div class="filters-grid">
            <div class="filter-group">
              <label class="filter-label">
                <i class="fas fa-user filter-icon"></i>
                Nome
              </label>

              <v-text-field
                v-model="name"
                placeholder="Digite o nome da lista de compras"
                outlined
                dense
                hide-details
                class="modern-input"
              />
            </div>

            <div class="filter-group">
              <label class="filter-label">
                <i class="fas fa-tag filter-icon"></i>
                Tipo
              </label>

              <v-select
                :items="[
                  { id: 'MEDICINE', name: 'Medicamento' },
                  { id: 'PRODUCT', name: 'Produtos' },
                ]"
                item-text="name"
                item-value="id"
                v-model="type"
                outlined
                dense
                hide-details
                class="modern-select"
                placeholder="Selecione o tipo"
              />
            </div>

            <div class="filter-group">
              <label class="filter-label">
                <i class="fas fa-clock filter-icon"></i>
                Data para realizar a compra
              </label>

              <v-text-field
                v-model="date_be_made"
                label="Selecionar Data"
                type="date"
                outlined
                dense
                hide-details
                class="modern-input"
              />
            </div>

            <div class="filter-group">
              <label class="filter-label">
                <i class="fas fa-user filter-icon"></i>
                Usuário responsável pela compra
              </label>

              <v-select
                v-model="user_id_will_buy"
                :items="users"
                item-text="name"
                item-value="id"
                clearable
                outlined
                ref="residentSelect"
                class="modern-select"
                placeholder="Selecione o usuário"
              />
            </div>
          </div>

          <div class="filter-group">
            <label class="filter-label">
              <i class="fas fa-search filter-icon"></i>
              Anotação
            </label>

            <v-textarea
              v-model="note"
              placeholder="Digite a anotação"
              outlined
              dense
              hide-details
              class="modern-input"
              maxlength="255"
            />
          </div>

          <div class="form-actions">
            <v-btn :disabled="loading" class="btn-save-modern" @click="create">
              <i class="fas fa-save mr-2"></i>
              {{ loading ? "Salvando..." : "Salvar Lista de Compras" }}
            </v-btn>
          </div>
        </div>

        <ErrorsMessages :errors="errors" />
      </div>
    </b-modal>
  </div>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages";

import toast from "../../lib/ToastNotification";

import api from "../../services/api";

export default {
  name: "BuyCreate",

  components: {
    ErrorsMessages,
  },

  data() {
    return {
      loading: null,

      name: null,

      type: null,

      date_be_made: null,

      user_id_will_buy: null,

      note: null,

      users: [],

      errors: [],
    };
  },

  mounted() {
    this.getUsers();
  },

  methods: {
    async getUsers() {
      try {
        this.loading = true;

        const response = await api.get("/rest-home/users");

        const { error, users } = response.data;

        if (!error) {
          this.users = users;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.error(error);
      }
    },

    async create() {
      try {
        this.loading = true;

        const { name, type, date_be_made, user_id_will_buy, note } = this;

        let params = {
          name,
          type,
          date_be_made,
          user_id_will_buy,
          note,
        };

        const response = await api.post("/buy", params);

        const { error, errors, message, buy_id } = response.data;

        if (!error) {
          toast(message, "success");

          this.$emit("created", buy_id);

          this.$bvModal.hide("buy-create");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    clearFields() {
      this.name = null;

      this.type = null;

      this.date_be_made = null;

      this.user_id_will_buy = null;

      this.note = null;

      this.errors = [];
    },
  },
};
</script>

<style scoped>
.form-actions {
  display: flex;
  justify-content: flex-end;
  padding: 16px;
}

.btn-save-modern {
  margin-left: auto;
}
</style>